// extracted by mini-css-extract-plugin
export default {"paper":"DocumentDefaultTemplate_paper__YfkBZ","content":"DocumentDefaultTemplate_content__KdTF2","textContainer":"DocumentDefaultTemplate_textContainer__ptjtM"};